import BillDetailsPage from './BillDetails.page';

export default BillDetailsPage;
